import { call } from 'redux-saga/effects';

export const changeFiltersStrategyCreator = (
    getFilteredResults,
    getNewDoc,
    updateDOMWithNewFilters,
    updateDOMWithNewProducts,
) => ({
    immediatelyUpdate: function* immediatelyUpdate(uri) {
        yield call(getFilteredResults, uri);
        const newDoc = yield call(getNewDoc);
        yield call(updateDOMWithNewFilters, newDoc);
        yield call(updateDOMWithNewProducts, newDoc);
    },
    updateAfterApply: function* updateAfterApply(uri) {
        yield call(getFilteredResults, uri);
        const newDoc = yield call(getNewDoc);
        yield call(updateDOMWithNewFilters, newDoc);
    },
});

export const getStrategyName = (config = {}, forceUpdate = false) =>
    forceUpdate ? config.forceUpdating : config.updating;
